import admanagerDELogoSignet from '@shared/assets/images/admanager-logo-de-signet.svg';
import admanagerDELogo from '@shared/assets/images/admanager-logo-de.svg';
import admanagerESLogo from '@shared/assets/images/admanager-logo-es.svg';
import admanagerLogoSignet from '@shared/assets/images/admanager-logo-signet.svg';
import admanagerLogo from '@shared/assets/images/admanager-logo.svg';
import { UserCountryCode, UserCountryCodes } from '@shared/types/countryCodes.ts';

export interface AdmanagerBrandData {
  logoSrc: string;
  logoSignetSrc: string;
  altText: string;
}

export function determineAdmanagerBrandData(countryCode: UserCountryCode | null): AdmanagerBrandData {
  switch (countryCode) {
    case UserCountryCodes.DE: {
      return {
        logoSrc: admanagerDELogo,
        logoSignetSrc: admanagerDELogoSignet,
        altText: 'Prosiebensat.1 AdManager',
      };
    }
    case UserCountryCodes.ES: {
      return {
        logoSrc: admanagerESLogo,
        logoSignetSrc: admanagerLogoSignet,
        altText: 'Mediaset España AdManager',
      };
    }
    default: {
      return {
        logoSrc: admanagerLogo,
        logoSignetSrc: admanagerLogoSignet,
        altText: 'Mediaset AdManager',
      };
    }
  }
}
